import { render, staticRenderFns } from "./form-prospect.vue?vue&type=template&id=251b9f9e&"
import script from "./form-prospect.vue?vue&type=script&lang=js&"
export * from "./form-prospect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports